import { useEffect, useState } from 'react';
import PatientDetailsPage from './PatientDetailsPage';
import { DirectoryRow } from '../billing-admin-home/BIllingAdminConstant';
import { Logger } from 'src/latest/src/services';
import { Spinner } from 'react-bootstrap';
import { getBillingHomepage } from 'src/redux/services/billingServices';
import { useParams } from 'react-router-dom';
import './PatientDetails.scss';
import { useSelector } from 'react-redux';

const PatientDetails = () => {
  const isDirectory = useSelector(
    (state: any) => state.configuration.isDirectoryPlatform,
  );
  const isDirectoryPlatform = isDirectory === 'true';
  const [isConfigLoading, setIsConfigLoading] = useState<boolean>(true);
  const [directoryPatientData, setDirectoryPatientData] =
    useState<DirectoryRow | null>(null);
  const { clientId } = useParams();

  useEffect(() => {
    const getDirectoryConfiguration = async () => {
      try {
        if (isDirectoryPlatform && clientId) {
          const payload = {
            user_ids: [clientId],
          };

          const patientData = await getBillingHomepage(payload);

          setDirectoryPatientData(
            patientData?.rows && patientData.rows.length > 0
              ? patientData.rows[0]
              : null,
          );
        }
      } catch (error) {
        Logger.error('Failed to fetch directory configuration:', error);
      } finally {
        setIsConfigLoading(false);
      }
    };

    getDirectoryConfiguration();
  }, []);

  if (isConfigLoading) {
    return (
      <div className="patient-details">
        <div className="patient-details-wrapper">
          <div className="d-flex justify-content-center align-items-center config-loading-spinner">
            <Spinner
              animation="border"
              role="status"
              variant="dark"
              className="mx-auto"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <PatientDetailsPage
      isDirectoryPlatform={isDirectoryPlatform}
      directoryPatientData={directoryPatientData}
    />
  );
};

export default PatientDetails;
